import { axiosInstanceV2 } from "@src/shared/api";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { NOTIFICATIONS_API_URL } from "../constants";
import { NotificationsHistoryResponseDto } from "../interfaces/notificationsHistoryResponseDto";

export const getNotificationsHistory = async (
  offset: number,
  limit: number,
  id: number,
) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;

  const response = await axiosInstanceV2.get<NotificationsHistoryResponseDto>(
    NOTIFICATIONS_API_URL.getHistory(offset, limit, id),
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );

  return response.data;
};
